module.exports = __webpack_public_path__ + "img/724.2360efa2.png";